import styles from './InfoModal.module.css';

// ── Modal genérico para las tarjetas del panel del propietario (UserDashboard) ──
export default function InfoModal({ title, icon, color, onClose, children }) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className={`modal ${styles.infoModal}`} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <div className={styles.cabeceraTitulo}>
            <div className={styles.iconoCaja} style={{ '--fondo': color + '18', '--tono': color }}>
              <i className={`fas ${icon} ${styles.glifo}`} />
            </div>
            <h3 className={styles.titulo}>{title}</h3>
          </div>
          <button className="btn-close" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
}
